module.exports = __webpack_public_path__ + "img/add-sector.2c0c4bfe.svg";